import { LegacyDeeplinksRules } from 'services/deeplinks/types';

export const NotAuthenticatedDeeplinks: string[] = [
  '/signup',
  '/signup/verify-email',
  '/signup/verify-sms',
  '/signup/verify-device',
  '/login',
  '/login/verify-email',
  '/login/verify-sms',
  '/login/verify-device',
  '/accept-challenge-v2',
  '/create-password',
  '/help',
];

export const NotAuthenticatedPartialDeeplinks: string[] = [
  '/challenge/magic-link/',
  '/payments/',
  '/payments-detail/',
  '/payments-confirmation/',
  '/challenge/cst-link/',
  '/challenge/cst-token-sms/',
];

export const LegacyDeeplinks: LegacyDeeplinksRules = {
  '/chat': {
    cruisePath: '/myvaro/help/chat',
  },
  '/varo-line-of-credit': {
    cruisePath: '/varo-line-of-credit/line-of-credit-entry-point',
  },
  '/perks': {
    cruisePath: '/rewards',
  },
  '/move': {
    cruisePath: '/move-money',
  },
  '/move/v2v': { cruisePath: '/move-money/v2a' },
  '/move/v2a': {
    cruisePath: '/move-money/v2a',
  },
  '/move/v2v/transfer': {
    cruisePath: '/move-money/v2a/transfer',
  },
  '/move/direct-deposit': {
    cruisePath: '/move-money/direct-deposit',
  },
  '/mobile-check-deposit': {
    cruisePath: '/move-money/check-deposit',
  },
  '/move/zelle': {
    cruisePath: '/move-money/zelle',
  },
  '/move/find-atm': {
    cruisePath: '/move-money/find-atm',
  },
  '/move/transfer/new': {
    cruisePath: '/move-money/transfer/transfer-money',
  },
  '/move/check-deposit-history': {
    cruisePath: '/move-money/check-deposit-history',
  },
  '/dispute-status': {
    cruisePath: '/myvaro/disputes',
  },
  '/myvaro/card/change-pin/cardtype/debit': {
    cruisePath: '/myvaro/card/debit',
  },
  '/myvaro/account-numbers': {
    cruisePath: '/myvaro/manage-accounts/account-numbers',
  },
  '/settings/notifications': {
    cruisePath: '/myvaro/settings',
  },
  '/myvaro/notifications': {
    cruisePath: '/myvaro/settings',
  },
  '/myvaro/profile/change-address': {
    cruisePath: '/myvaro/personal-details/change-address',
  },
  '/myvaro/profile/change-mailing-address': {
    cruisePath: '/myvaro/personal-details/change-mailing-address',
  },
  '/myvaro/profile': {
    cruisePath: '/myvaro/personal-details',
  },
};
